var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('ozi-loading',{attrs:{"loading":!_vm.participations}}),_c('ozi-table',{attrs:{"items":_vm.participations,"headers":_vm.headers,"hide-default-footer":true,"disable-pagination":""},scopedSlots:_vm._u([{key:"item.survey.duedate",fn:function(ref){
var item = ref.item;
return [(item.participationduedate)?[_vm._v(" "+_vm._s(_vm.$d(new Date(item.participationduedate), 'short'))+" ")]:(item.survey.duedate)?[_vm._v(" "+_vm._s(_vm.$d(new Date(item.survey.duedate), 'short'))+" ")]:[_vm._v("- ")]]}},{key:"item._actions",fn:function(ref){
var item = ref.item;
return [_c('ozi-button',{attrs:{"to":{
          name: 'survey-report',
          params: { participantId: item.id, path: '1' },
        }}},[_vm._v(_vm._s(_vm.$tc('page.dashboard.provider.survey.view')))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }